'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Credit';

var EntypoCredit = function EntypoCredit(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M11,16.755V19H9v-2.143c-1.712-0.1-3.066-0.589-4.241-1.797l1.718-1.74c0.859,0.87,2.023,1.16,3.282,1.16c1.565,0,2.405-0.599,2.405-1.702c0-0.483-0.133-0.889-0.42-1.16c-0.267-0.251-0.572-0.387-1.202-0.483L8.9,10.903c-1.164-0.174-2.022-0.541-2.634-1.141C5.618,9.105,5.293,8.216,5.293,7.055c0-2.155,1.382-3.743,3.707-4.1V1h2v1.932c1.382,0.145,2.465,0.62,3.415,1.551l-1.679,1.682c-0.859-0.832-1.889-0.947-2.787-0.947c-1.412,0-2.099,0.792-2.099,1.74c0,0.348,0.115,0.716,0.401,0.986c0.267,0.252,0.706,0.464,1.26,0.541l1.602,0.232c1.241,0.174,2.023,0.522,2.596,1.063c0.726,0.696,1.05,1.702,1.05,2.92C14.759,14.95,13.192,16.362,11,16.755z' })
    );
};

exports.default = EntypoCredit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo-icons/lib/entypo/Credit.js
// module id = 540
// module chunks = 168707334958949